module.exports = __webpack_public_path__ + "static/img/juhuaR22.d8cc0ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productList/juhua/juhuaR22.jpg
// module id = FeIW
// module chunks = 1